import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Collapse,
  UncontrolledTooltip,
} from "reactstrap";
import _ from "lodash";
import Moment from "moment";
import { Multiselect } from "react-widgets";

import SmileDatepicker from "components/Datepicker";

const SearchForm = ({
  searchParams,
  onChangeCollectionsHOC,
  getCollections,
  getCollectionsByDr,
  selectedCompany,
  data,
  exportReport,
  exportSSTReport,
  getInvoices,
  doctors,
  selectedBranchID,
  exportLabCostsReport,
  getSelectedCompany,
}) => {
  const [isCardOpen, updateIsCardOpen] = useState(false);
  return (
    <Card className="main-card mb-3">
      <CardHeader
        id="search-bar-toggle"
        className="d-flex justify-content-between"
        onClick={() => updateIsCardOpen(!isCardOpen)}
      >
        <Label className="m-0">Search</Label>
        <i
          className={isCardOpen ? "pe-7s-angle-up" : "pe-7s-angle-down"}
          style={{ fontSize: "3rem", color: "#000" }}
        />
        <UncontrolledTooltip target="search-bar-toggle" placement="top-end">
          {isCardOpen ? "Collapse" : "Expand"}
        </UncontrolledTooltip>
      </CardHeader>
      <Collapse isOpen={isCardOpen}>
        <CardBody>
          <Form onSubmit={(e) => e.preventDefault()}>
            <FormGroup>
              <Label>{"Select a company"}</Label>
              <Input
                type="select"
                value={searchParams[0]["value"]}
                onChange={(e) => {
                  getSelectedCompany(e.target.value);
                  let tmp = _.cloneDeep(searchParams);
                  tmp[0]["value"] = e.target.value;
                  onChangeCollectionsHOC("searchParams", tmp);
                }}
              >
                <option></option>
                {data.profileReducer.profile.companies.map((item) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  );
                })}
              </Input>
            </FormGroup>
            {data.profileReducer.profile.current_user.role.name ===
              "Super Admin" && (
              <FormGroup>
                <Label>Select branch</Label>
                <Input
                  type="select"
                  value={selectedBranchID}
                  onChange={(e) => {
                    onChangeCollectionsHOC("selectedBranchID", e.target.value);
                  }}
                >
                  <option></option>
                  {selectedCompany.branches.map((item) => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
                </Input>
              </FormGroup>
            )}
            {(data.profileReducer.profile.current_user.role.name === "Admin" ||
              data.profileReducer.profile.current_user.role.name === "Doctor" ||
              data.profileReducer.profile.current_user.role.name ===
                "Frontdesk") && (
              <FormGroup>
                <Label>
                  Select branch
                  {searchParams[3]["value"].length > 0 && (
                    <span className="text-warning">
                      {" "}
                      (search result based on doctor selection)
                    </span>
                  )}
                </Label>
                <Input
                  type="select"
                  value={selectedBranchID}
                  // disabled={ searchParams[ 3 ][ 'value' ].length > 0 }
                  onChange={(e) => {
                    onChangeCollectionsHOC("selectedBranchID", e.target.value);
                  }}
                >
                  <option></option>
                  {data.profileReducer.profile.branches.map((item) => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
                </Input>
              </FormGroup>
            )}
            {(data.profileReducer.profile.current_user.role.name === "Admin" ||
              data.profileReducer.profile.current_user.role.name ===
                "Frontdesk") && (
              <FormGroup>
                <Label>{"Select a doctor"}</Label>
                <Multiselect
                  data={_.filter(
                    doctors,
                    (doctor) =>
                      _.findIndex(
                        doctor.company_ids,
                        (company) =>
                          company === parseInt(searchParams[0]["value"])
                      ) > -1
                  )}
                  textField={"name"}
                  itemComponent={(e) => (
                    <span>{`${e.item.salutation} ${e.item.name}`}</span>
                  )}
                  value={_.filter(
                    doctors,
                    (doctor) =>
                      _.findIndex(
                        searchParams[3]["value"],
                        (item) => item === doctor.id
                      ) > -1
                  )}
                  onChange={(val) => {
                    let tmp = _.cloneDeep(searchParams);
                    tmp[3]["value"] =
                      val.length > 0 ? [val[val.length - 1].id] : [];
                    onChangeCollectionsHOC("searchParams", tmp);
                  }}
                />
              </FormGroup>
            )}
            <FormGroup>
              <Label>Start date</Label>
              <SmileDatepicker
                showTimeSelect={false}
                selectedDate={searchParams[1]["value"]}
                onChange={(val) => {
                  let tmp = _.cloneDeep(searchParams);
                  tmp[1]["value"] = val;
                  onChangeCollectionsHOC("searchParams", tmp);
                }}
                dateFormat="MMMM d, yyyy"
                disabled={
                  data.profileReducer.profile.current_user.role.name ===
                  "Frontdesk"
                }
              />
            </FormGroup>
            <FormGroup>
              <Label>End date</Label>
              <SmileDatepicker
                showTimeSelect={false}
                selectedDate={searchParams[2]["value"]}
                onChange={(val) => {
                  let tmp = _.cloneDeep(searchParams);
                  tmp[2]["value"] = val;
                  onChangeCollectionsHOC("searchParams", tmp);
                }}
                dateFormat="MMMM d, yyyy"
                disabled={
                  data.profileReducer.profile.current_user.role.name ===
                  "Frontdesk"
                }
              />
            </FormGroup>
            <div className="mt-4">
              <Button
                color="primary"
                style={{ marginRight: "10px", display: "inline-block" }}
                onClick={() => {
                  getCollections(
                    searchParams[0]["value"],
                    Moment(searchParams[1]["value"]).format("YYYY-MM-DD"),
                    Moment(searchParams[2]["value"]).format("YYYY-MM-DD"),
                    searchParams[3]["value"]
                  );
                }}
              >
                {"Search"}
              </Button>
              <Button
                color="danger"
                style={{ marginRight: "10px", display: "inline-block" }}
                onClick={() => {
                  getCollections(
                    data.profileReducer.profile.current_user.company_ids
                      .length > 0
                      ? data.profileReducer.profile.current_user.company_ids[0]
                      : 0,
                    Moment(new Date()).format("YYYY-MM-DD"),
                    Moment(new Date()).format("YYYY-MM-DD"),
                    searchParams[3]["value"]
                  );
                  onChangeCollectionsHOC("searchParams", [
                    {
                      key: "company_id",
                      value:
                        data.profileReducer.profile.current_user.company_ids
                          .length > 0
                          ? data.profileReducer.profile.current_user
                              .company_ids[0]
                          : 0,
                    },
                    {
                      key: "start_date",
                      value: new Date(),
                    },
                    {
                      key: "end_date",
                      value: new Date(),
                    },
                    {
                      key: "dr_id",
                      value: [],
                    },
                  ]);
                }}
              >
                {"Reset"}
              </Button>
              <Button
                color="primary"
                style={{ marginRight: "10px", display: "inline-block" }}
                onClick={() => {
                  exportReport({
                    company_id: searchParams[0]["value"],
                    start_date: Moment(searchParams[1]["value"]).format(
                      "YYYY-MM-DD"
                    ),
                    end_date: Moment(searchParams[2]["value"]).format(
                      "YYYY-MM-DD"
                    ),
                    user_ids: searchParams[3]["value"],
                  });
                }}
              >
                Export report
              </Button>
              <Button
                color="primary"
                style={{ marginRight: "10px", display: "inline-block" }}
                onClick={() => {
                  exportLabCostsReport({
                    company_id: searchParams[0]["value"],
                    start_date: Moment(searchParams[1]["value"]).format(
                      "YYYY-MM-DD"
                    ),
                    end_date: Moment(searchParams[2]["value"]).format(
                      "YYYY-MM-DD"
                    ),
                    user_ids: searchParams[3]["value"],
                  });
                }}
              >
                Export report with lab costs
              </Button>
              <Button
                color="primary"
                style={{ marginRight: "10px", display: "inline-block" }}
                onClick={() => {
                  exportSSTReport({
                    company_id: searchParams[0]["value"],
                    start_date: Moment(searchParams[1]["value"]).format(
                      "YYYY-MM-DD"
                    ),
                    end_date: Moment(searchParams[2]["value"]).format(
                      "YYYY-MM-DD"
                    ),
                    user_ids: searchParams[3]["value"],
                  });
                }}
              >
                Export SST report
              </Button>
              <Button
                color="primary"
                style={{ marginRight: "10px", display: "inline-block" }}
                onClick={() => {
                  let tmp = _.cloneDeep(searchParams);
                  getInvoices(
                    tmp[0]["value"],
                    Moment(tmp[1]["value"]).format("YYYY-MM-DD"),
                    Moment(tmp[2]["value"]).format("YYYY-MM-DD"),
                    tmp[3]["value"]
                  );
                }}
              >
                Show invoices
              </Button>
              <Button
                color="primary"
                style={{ marginRight: "10px", display: "inline-block" }}
                onClick={() => {
                  let tmp = _.cloneDeep(searchParams);
                  getInvoices(
                    tmp[0]["value"],
                    Moment(tmp[1]["value"]).format("YYYY-MM-DD"),
                    Moment(tmp[2]["value"]).format("YYYY-MM-DD"),
                    tmp[3]["value"]
                  );
                }}
              >
                Show invoices
              </Button>
            </div>
          </Form>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default SearchForm;
